"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vuex_1 = require("vuex");
var Map_1 = require("../models/Map");
var InfoWindow_1 = require("../models/InfoWindow");
var DashboardMap = /** @class */ (function (_super) {
    __extends(DashboardMap, _super);
    function DashboardMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.map = new Map_1.default(4, { lat: 41.850033, lng: -98.6500523 });
        _this.infoWindow = new InfoWindow_1.default({ pixelOffset: { width: 0, height: -35 } });
        _this.markers = [];
        _this.currentMarkerIndex = null;
        return _this;
    }
    DashboardMap.prototype.closeInfoWindow = function () {
        this.infoWindow.open = false;
        this.infoWindow.content = '';
    };
    ;
    DashboardMap.prototype.toggleInfoWindow = function (marker, index) {
        var cities = [];
        if (marker.cities) {
            for (var i = 0; i < marker.cities.length; i++) {
                cities.push({
                    id: marker.cities[i].id,
                    name: marker.cities[i].name
                });
            }
        }
        var codes = '';
        for (var i = 0; i < marker.color_codes.length; i++) {
            codes += "<div style=\"background-color: ".concat(marker.color_codes[i].color, "\" class=\"status\">\n                            <a href=\"/risk-rating?color_code=").concat(marker.color_codes[i].name, "\">").concat(marker.color_codes[i].name.toUpperCase(), "</a>\n                        </div>");
        }
        this.infoWindow.position = { lat: marker.lat, lng: marker.lng };
        this.infoWindow.content = "\n                <div class=\"map-content\">\n                    <h3>\n                        <a href=\"/world-guide/country?id=".concat(marker.id, "\">").concat(marker.country.name, "</a>\n                    </h3>\n                    <div class=\"country-status-info-wrap\">\n                        <div class=\"ttl\">Status: </div>\n                        ").concat(codes, "\n                    </div>\n\n                    <p>").concat(cities.length ? '<strong>City Guides:</strong>' : '', "</p>\n\n                    ").concat(cities.map(function (city, index) { return "\n                        <a href=\"/world-guide/city?id=".concat(city.id, "\">").concat(index === cities.length - 1 ? city.name : city.name + ', ', "</a>\n                    "); }).join(''), "\n                    <a href=\"/world-guide/country?id=").concat(marker.id, "\" class=\"btn btn-secondary mt-3\">More</a>\n                </div>\n            ");
        this.map.center = { lat: marker.lat + 20, lng: marker.lng };
        if (this.currentMarkerIndex === index) {
            this.infoWindow.open = !this.infoWindow.open;
        }
        else {
            this.infoWindow.open = true;
            this.currentMarkerIndex = index;
        }
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)()
    ], DashboardMap.prototype, "input_country_guides", void 0);
    DashboardMap = __decorate([
        (0, vue_property_decorator_1.Component)({
            mounted: function () {
                this.markers = this.input_country_guides.map(function (el) { return (__assign(__assign({}, el), { icon: {
                        url: '/img/svg/pin-4.svg',
                        scaledSize: { width: 32, height: 40 },
                        labelOrigin: { x: 16, y: -10 }
                    } })); });
            },
            computed: (0, vuex_1.mapGetters)(['GET_MARKERS_LIST'])
        })
    ], DashboardMap);
    return DashboardMap;
}(vue_property_decorator_1.Vue));
exports.default = DashboardMap;
